import { AreaChart, Area, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import type { Transaction } from "../../types/api";

interface TransactionsSparklineProps {
  data: Transaction[];
}

export const TransactionsSparkline = ({ data }: TransactionsSparklineProps) => {
  const chartData = data
    .slice(0, 10)
    .reverse()
    .map((transaction) => ({
      date: new Date(transaction.createdAt).toLocaleDateString(),
      amount: transaction.amount,
    }));

  return (
    <div className="h-40 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData}>
          <defs>
            <linearGradient id="txGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#22d3ee" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#22d3ee" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="date" hide />
          <Tooltip
            contentStyle={{
              background: "rgba(2,6,23,0.9)",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.1)",
            }}
          />
          <Area
            type="monotone"
            dataKey="amount"
            stroke="#22d3ee"
            fillOpacity={1}
            fill="url(#txGradient)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
